export default __webpack_public_path__ + "static/media/liveTest.af73ded7.svg";